export const useUserStore = defineStore('userData', () => {
  const appConfigStore = useAppConfigStore()
  const appConfig = appConfigStore.appConfig
  const isHidePriceCookie = useCookie('isHidePrice')
  // const isHideGrandTotalCookie = useCookie('isHideGrandTotal') // Cookie-based toggle disabled for now
  const cookieOptions = appConfig.public?.COOKIE_DOMAIN
    ? {
        domain: appConfig.public?.COOKIE_DOMAIN,
        sameSite: 'strict'
      }
    : undefined
  const selectedShowCustomerCookie = useCookie('selectedShowCustomer', cookieOptions)

  const userData = ref({
    customerCode: '',
    email: '',
    email2: '',
    userGroup: '',
    companyName: '',
    isHidePrice: false,
    isHideGrandTotal: true,
    selectedShowCustomer: null
  })

  // const loggedIn = computed(() => {
  //   console.log(`loggedIn > userData.value: ${userData.value?.email}`)
  //   return !!userData.value && !!userData.value.email && existsCookie()
  // })

  // const existsUserData = computed(() => {email
  //   return !!userData.value && !!userData.value.email
  // })

  // computed
  const isAdmin = computed(() => {
    return ['N41', 'ADMIN'].includes(userData.value.userGroup)
  })

  const isSalesRep = computed(() => {
    return ['WEB_SHOW_USER'].includes(userData.value.userGroup)
  })
  const isCustomerMode = computed(() => {
    return ['WEB_USER'].includes(userData.value.userGroup)
  })
  const isGuestMode = computed(() => {
    return (
      appConfig?.web?.guestAccountCodes?.some(
        (code) => code.toLowerCase() === userData.value.customerCode.toLowerCase()
      ) ?? false
    )
  })
  const isReadOnlyCustomerMode = computed(() => {
    if (isGuestMode.value) return true
    if (appConfig?.web?.isReadOnlyCustomerMode) {
      if (isSalesRep.value) {
        return false
      } else {
        return appConfig?.web?.isReadOnlyCustomerMode
      }
    }
  })

  const setUserData = (_userData) => {
    //console.log(`setUserData() userData: ${_userData?.email}`, _userData)

    if (!_userData?.email) return

    userData.value.customerCode = _userData.customerCode
    userData.value.email = _userData.email
    userData.value.email2 = _userData.email2
    userData.value.userGroup = _userData.userGroup
    userData.value.companyName = _userData.companyName
    userData.value.isHidePrice = isHidePriceCookie.value ?? false
    // userData.value.isHideGrandTotal = isHideGrandTotalCookie.value ?? true
    userData.value.isHideGrandTotal = true // Forced true; cookie-based toggle disabled for now
    userData.value.selectedShowCustomer = selectedShowCustomerCookie.value ?? null
  }
  const refreshHideGrandTotal = () => {
    // const isHideGrandTotalCookie = useCookie('isHideGrandTotal')
    // userData.value.isHideGrandTotal = isHideGrandTotalCookie.value ?? true
    userData.value.isHideGrandTotal = true // Forced true; cookie-based toggle disabled for now
  }
  const refreshSelectedShowCustomer = () => {
    const selectedShowCustomer = useCookie('selectedShowCustomer')
    userData.value.selectedShowCustomer = selectedShowCustomer.value ?? null
    //userData.value.selectedShowCustomer = selectedShowCustomerCookie.value ?? null // One tempo late.
  }
  const resetSelectedShowCustomer = () => {
    const selectedShowCustomer = useCookie('selectedShowCustomer')
    selectedShowCustomer.value = null
    userData.value.selectedShowCustomer = null
  }
  const isLoggedIn = () => {
    return !!userData.value && !!userData.value.email
  }

  const clearUserData = () => {
    //console.log('>> User Store > logout', isSalesRep.value)
    userData.value = {}
    selectedShowCustomerCookie.value = null
    navigateTo('/login')
    //companyCode.value = null
    //refreshCookie('pim_cAlias')
  }

  return {
    userData,
    isAdmin,
    isSalesRep,
    isCustomerMode,
    isGuestMode,
    isReadOnlyCustomerMode,
    isLoggedIn,
    setUserData,
    clearUserData,
    refreshHideGrandTotal,
    refreshSelectedShowCustomer,
    resetSelectedShowCustomer
  }
})
